<template>
    <div id='main-container' class='container-fluid'>
        <section id='content'>
            <div class='row'>
                <div class='col centered'>
                    <h1 class='title'>
                        Bienvenue sur Credicys,
                    </h1>
                    <h2>
                        plateforme de traitement des petites créances
                    </h2>
                </div>
            </div>

            <div class='row separation'>
                <div class='col centered'>
                    <button class='btn btn-primary btn-credicys' data-toggle='modal' data-target='#modal'>JE DEBUTE LA PROCÉDURE</button>
                </div>
            </div>
        </section>
        <section id='how-it-works'>
            <div class='row'>
                <div class='col centered'>
                    <h2 class='subtitle red'>
                        Comment ça marche ?
                    </h2>
                </div>
            </div>
            <div class='row'>
                <div class='col centered iconCol'>
                    <p class='textAboveIcon'>Vous êtes actuellement à cette étape</p>
                </div>
                <div class='col centered iconCol'>
                </div>
                <div class='col centered iconCol'>
                </div>
            </div>
            <div class='row'>
                <div class='col centered rb iconCol'>
                    <span class='icon icon-circle1'></span>
                    <p class='textUnderIcon'>Je reçois un courrier <br/>du Commissaire de justice</p>
                </div>
                <div class='col centered rb iconCol'>
                    <span class='icon icon-circle2'></span>
                    <p class='textUnderIcon'>J'entre en relation<br/>avec le Commissaire de justice</p>
                </div>
                <div class='col centered iconCol'>
                    <span class='icon icon-circle3'></span>
                    <p class='textUnderIcon'>Si accord, je paie<br/>les sommes convenues</p>
                </div>
            </div>
        </section>
        <section id='advantages'>
            <div class='row'>
                <div class='col centered'>
                    <h2 class='subtitle red'>
                        Les avantages
                    </h2>
                </div>
            </div>
            <div class='row mb1'>
                <div class='col centered iconCol'>
                    <span class='icon icon-lock'></span>
                    <p class='textUnderIcon'>La procédure se déroule en<br/>ligne de manière totalement<br/>dématerialisée</p>
                </div>
                <div class='col centered iconCol'>
                    <span class='icon icon-edit'></span>
                    <p class='textUnderIcon'>En acceptant la procédure<br/>aucun frais n'est à votre<br/>charge</p>
                </div>
                <div class='col centered iconCol'>
                    <span class='icon icon-price'></span>
                    <p class='textUnderIcon'>Des facilités de paiement sont<br/>envisageables<br/><br/></p>
                </div>
            </div>
            <div class='row pb1'>
                <div class='col centered'>
                    <button class='btn btn-primary btn-credicys' data-toggle='modal' data-target='#modal'> JE DEBUTE LA PROCÉDURE</button>
                </div>
            </div>
        </section>

        <div class='modal fade' id='modal' tabindex='-1' role='dialog' aria-labelledby='modal' aria-hidden='true'>
            <div class='modal-dialog' role='document'>
                <div class='modal-content'>
                    <div class='modal-header'>
                        <h5 class='card-title text-center'><span class='icon-lock'></span> Connexion</h5>
                        <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                    <form novalidate action='#' @submit.prevent='connect'>
                    <div class='modal-body'>
                            <div class='form-group row'>
                                <div class='col-sm-12' style='min-height: 80px;'>
                                    <input type='text' class='form-control' id='security_code'
                                           placeholder='Entrez votre Code de sécurité'
                                           onfocus='this.placeholder=""'
                                           onblur='this.placeholder="Entrez votre Code de sécurité"' v-model='security_code'
                                           :class="[{'form-control':true, 'is-invalid' : !validSecurityCode(security_code) && blur_security_code},{'form-control':true, 'is-valid' : validSecurityCode(security_code) && blur_security_code}]"
                                           v-on:blur='blur_security_code = true'/>
                                    <div class='invalid-feedback'>
                                        {{ error_security_code }}
                                    </div>
                                    <div class='valid-feedback'>
                                        Code de sécurité valide.
                                    </div>
                                </div>
                                <div class='col-sm-12'>
                                    <i>Vous trouverez votre code dans le courrier recommandé qui vous a été adressé.</i>
                                </div>
                            </div>
                    </div>
                    <div class='modal-footer'>
                        <button class='btn btn-lg btn-primary btn-block text-uppercase' type='submit'>
                            <span class='icon-signin'></span> Se connecter
                        </button>
                        <button type='button' class='btn btn-secondary' data-dismiss='modal'>Fermer</button>
                    </div>
                    </form>
                    <div id='loader-container' style='text-align: center'>
                        <PulseLoader :loading='loading' :color='color' :size='size'></PulseLoader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        name: 'security-code-connection',
        components: {
            PulseLoader
        },
        computed: {
            valid: function () {
                return this.valid_security_code;
            }
        },
        data() {
            return {
                //PulseLoader props
                loading: false,
                color: '#d93752',
                size: '1em',
                //Component intern props
                security_code: '',
                valid_security_code: false,
                error_security_code: '',
                blur_security_code: false,
                unknown_security_code: ''
            }
        },
        methods: {
            connect: function() {
                this.validate();
                if (this.valid) {
                    this.loading = true;
                    this.$store.dispatch('postApi', {
                        'controller':'PCDossierDebtor',
                        'action':'findBySecurityCode',
                        'post': {
                            securityCode: this.security_code
                        }
                    })
                        .then(response => {
                            if(response.data.response.success==1) {
                                window.location.href = 'index.php?type=debtor&id=' + response.data.session.protagonistId;
                            }else {
                                this.unknown_security_code = this.security_code;
                            }
                            this.loading = false;
                        })
                }
            },
            validate: function () {
                this.blur_security_code = true;
                if (this.validSecurityCode(this.security_code)) {
                    this.valid_security_code = true;
                } else {
                    this.valid_security_code = false;
                }
            },
            validSecurityCode: function (security_code) {
                if (this.security_code.trim().length == 0) {
                    this.error_security_code = 'Merci de renseigner cotre Code de sécurité.'
                    return false;
                }

                if(this.unknown_security_code == security_code) {
                    this.error_security_code = 'Code de sécurité inconnu.'
                    return false;
                }

                return true;
            },
        }
    }
</script>
<style lang='scss' scoped>
    #main-container {
        padding: 0px !important;
        margin: 0px !important;
        background-color: #f7f7f7;
    }

    .btn-credicys {
        padding: 1em;
        border-radius: 2em;
        margin-bottom: 2em;
    }

    .title {
        margin-top: 2em;
    }

    .subtitle {
        margin-top: 2em;
        margin-bottom: 2em;
    }

    #how-it-works {
        min-height: 200px;
        background-color: white;
    }

    .icon {
        color: #d93752;
        font-size: 6em;
    }

    .iconCol {
        min-width: 500px;
    }

    .textAboveIcon {
        color: #d93752;
        font-weight: bold;
        font-size: 1rem;
    }

    .textUnderIcon {
        padding-top: 1em;
        text-transform: uppercase;
        font-size: 1rem;
    }

    .rb {
        border-right: 1px solid gray;
    }

    #advantages {
        background-image: url('../assets/advantage_background.jpg');
        background-size: cover;
    }

    .separation {
        height: 176px;
        background-image: url('../assets/header-background.jpg');
        background-size: cover;
    }

    @media(min-width:768px){
        .textUnderIcon {
            font-size: 1.5rem;
        }
    }

    @media(min-width:992px){
        .textUnderIcon {
            font-size: 2rem;
        }
    }
    @media(min-width:1200px){
        .textUnderIcon {
            font-size: 2rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/LandingPage.vue